import React, { useState, cloneElement, useRef, useEffect } from "react";
import cn from "classnames";
import styles from "./style.module.scss";

interface IProps {
  hideUnderline?: boolean;
  children?: React.ReactNode;
  overlayClass?: string;
  overlay: React.ReactElement;
  className: string;
}
const MIN_WIDTH = 256;

const Tooltip = ({
  children,
  overlay,
  hideUnderline,
  overlayClass,
  className,
}: IProps) => {
  const ref: any = useRef();
  const rect = ref?.current?.getBoundingClientRect();
  const [isOffScreenLeft, setOffScreenLeft] = useState(false);
  const [isOffScreenRight, setOffScreenRight] = useState(false);

  const determineOffScreen = () => {
    if (rect && typeof window !== "undefined") {
      const { left } = rect;
      setOffScreenLeft(left + MIN_WIDTH / 2 > window.innerWidth);
      setOffScreenRight(left - MIN_WIDTH / 2 < 0);
    }
  };

  useEffect(() => {
    determineOffScreen();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rect]);

  const tooltipClassNames = cn(className, styles.container, {
    [styles.hideUnderline]: hideUnderline,
  });

  let position = "middle";
  if (isOffScreenLeft) position = "right";
  if (isOffScreenRight) position = "left";

  const overlayClassName = cn(
    styles.overlay,
    styles[`overlay-${position}`],
    overlayClass
  );
  const [hover, toggleHover] = useState(false);
  return (
    <span
      ref={ref}
      onMouseEnter={() => toggleHover(true)}
      onMouseLeave={() => toggleHover(false)}
      onTouchStart={() => toggleHover(!hover)}
      className={tooltipClassNames}
    >
      {children}
      {hover &&
        cloneElement(overlay, {
          className: overlayClassName,
          "data-test": "tooltipElement",
        })}
    </span>
  );
};

export default Tooltip;
